import { useMatomo } from '@datapunt/matomo-tracker-react';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import React, { useEffect } from 'react';

import Header from '@components/common/Header/Header';
import DownloadIconBtn from '@components/common/Header/components/BtnHeaderDownload/BtnHeaderDownload';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { selectAppLocationSelectValue } from '@store/useAppStore';

import TableUsers from './components/TableUsers/TableUsers';
import UsersFilter from './components/UsersFilter/UsersFilter';
import { useExportUsersMutation } from './services/useExportUsersMutation';
import {
  selectUsersSearchValue,
  selectUsersStatusValue,
  selectUsersTableSortingValue,
} from './store/useUsersStore';
import style from './style.module.scss';

const Users = () => {
  const { trackPageView } = useMatomo();
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();
  const { mutate: exportUsersMutate } = useExportUsersMutation();

  const locationSelectValue = selectAppLocationSelectValue();
  const searchValue = selectUsersSearchValue();
  const userStatus = selectUsersStatusValue();
  const sorting = selectUsersTableSortingValue();

  useEffect(() => {
    trackPageView();
  }, []);

  const exportUsersList = () => {
    const currentDateFormat = `${profileData?.dateFormat.date} ${profileData?.dateFormat.time}`;
    showToast({ variant: 'success', message: t('The download will begin shortly.') });
    exportUsersMutate(
      {
        sorting,
        searchValue,
        userStatus,
        locationIds:
          locationSelectValue.level_name === 'allFacilities' ? undefined : locationSelectValue.filterIds,
      },
      {
        onSuccess: (data) => {
          saveAs(
            new Blob([data?.data], { type: 'text/plain;charset=utf-8' }),
            `${profileData?.customer?.name || ''} Users List ${format(new Date(), currentDateFormat)}.csv`,
          );
        },
      },
    );
  };

  return (
    <>
      <Header
        title={t('Manage Users')}
        showLogo={true}
        showFacilitySelect={true}
        headerRightComponent={
          <DownloadIconBtn tooltipInfo={t('Download User List Report')} downloadFn={exportUsersList} />
        }
      />
      <div className={style.manageUsers}>
        <UsersFilter />
        <TableUsers />
      </div>
    </>
  );
};

export default Users;
